module.exports = __webpack_public_path__ + "img/jiegou.8d0ceb4f.png";